module.exports = __webpack_public_path__ + "img/hita_white.f277d40b.png";